import _ from 'lodash';
import moment from "moment";
import React, { useEffect, useState } from 'react';
import styles from "./everNote.module.scss";
import { Modal, Popover, Select } from "antd";
import { URInput } from "../../../../shared/widgets/input";
import { URButton } from "../../../../shared/widgets/button";
import evernoteicon from '../../../../styles/images/evernote.svg';
import { toastInformation } from '../../../../base/callService/common';
import evernoteIcn  from '../../../../styles/images/evernote-icon-mdl.svg';
import { everNoteOauth, getEverNotebooks, saveNote, getNotes } from '../../../../base/utils';
import evernoteIcnNodata from "../../../../styles/images/nodataEvernote.svg"
import { URCheckBox } from '../../../../shared/widgets/checkbox';
import store from '../../../../context/store/store';

type urEvernoteState = {
    titleerror:boolean;
    isSigninModal:boolean;
    isCreateModal: boolean;
    isShareModal: boolean;
    listOfNoteBooks:any;
    defaultNoteBook:any;
    listOfNotes:any;
    listOfNotes1: any;
    searchTerm: string;
    searchResults:any;
    noteContent: {
      title:string;
      content:string;
      guid:string;

    }
}
 const { Option } = Select;
export const EvernoteStorage = ()=> {
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
 
  const [getEvernote,setEvernote] = useState<urEvernoteState>({
        isSigninModal:false,isCreateModal: false, isShareModal: false,
         listOfNoteBooks:[], listOfNotes: [], defaultNoteBook:[], searchTerm: '', listOfNotes1 : [], searchResults: [],noteContent :{
          title:'', content:'', guid:'' }, titleerror:false
      });

      const [evernoteBtn, setEverNoteBtn] = useState(false);


  const evernoteOptions =async(key:string)=> {
    let {isSigninModal} = getEvernote;
 
      const isEvernoteLogged = localStorage.getItem('evernoteuserid');
      if(isEvernoteLogged) {
        if(key === 'create') { createNoteModal(); }
        else if(key === 'share') {
          {shareNoteModal();}
        }
      }
      else {
          setEvernote({...getEvernote, isSigninModal:!isSigninModal});
      }
  }

  const createNoteModal=async()=> {
    let {isCreateModal, defaultNoteBook,noteContent } = getEvernote;
    let {guid} = noteContent;

    let notebooks:any =  await getEverNotebooks();
    if(notebooks && notebooks?.statusCode === 200) { 

     let tempdefaultNoteBook = _.filter(notebooks?.result, {"defaultNotebook": true});
  
     if( Array.isArray(tempdefaultNoteBook) && tempdefaultNoteBook.length > 0) {
         defaultNoteBook.push(tempdefaultNoteBook[0].name);
         guid = tempdefaultNoteBook[0].guid;
     }
    
     setEvernote({...getEvernote, isCreateModal:!isCreateModal,listOfNoteBooks :notebooks.result, defaultNoteBook : defaultNoteBook,noteContent:{...noteContent, guid: guid}});
    }
    else if(notebooks && notebooks?.statusCode === 401) {
        localStorage.removeItem('evernoteuserid');
      toastInformation(notebooks.message, "failure");
      setEvernote({...getEvernote, isSigninModal:!getEvernote.isSigninModal});
    }
    else {
      toastInformation(notebooks.message, "failure");
    }
  }

  const shareNoteModal=async()=> {
    let {isShareModal} = getEvernote;

    let notes:any =  await getNotes();
    if( notes.statusCode === 200) { 
      setEvernote({...getEvernote, isShareModal:!isShareModal, listOfNotes :notes.result.notes, listOfNotes1 :notes.result.notes});
    }
    else {
      toastInformation('unable to fetch notes list');
    }
    // if(notebooks.statusCode === 200) { 
    //   console.log("notebooks----", notebooks)

    //  let tempdefaultNoteBook = _.filter(notebooks.result, {"defaultNotebook": true});
  
    //  if(tempdefaultNoteBook.length > 0) {
    //      defaultNoteBook.push(tempdefaultNoteBook[0].name);
    //  }
    
    //  setEvernote({...getEvernote, isCreateModal:!isCreateModal,listOfNoteBooks :notebooks.result, defaultNoteBook : defaultNoteBook,noteContent:{...getEvernote.noteContent, guid: tempdefaultNoteBook[0].guid}});
    // }
    // else {
    //  toastInformation(notebooks.message, "failure");
    // }
  }

  const sendNote= async ()=> {
    if(!getEvernote.noteContent.title) {
      setEvernote({...getEvernote, titleerror:true });
    }
    else if(getEvernote.noteContent.title) {
      let createRes:any = await saveNote(getEvernote.noteContent);
       if(createRes.statusCode === 200 ) { 
         toastInformation(createRes.message, 'success');
       }
       else if(createRes.statusCode === 401) {
        localStorage.removeItem('evernoteuserid');
        toastInformation(createRes.message, "failure");
       }
       else {
        toastInformation(createRes.message, "failure");
       }
       closeCreateModalValue();
    }
 
  }

  const closeCreateModalValue=()=> {
    setEvernote({...getEvernote, isCreateModal: false, isShareModal: false, defaultNoteBook:[],titleerror:false, noteContent:{...getEvernote.noteContent , title:'',content:'',guid:''}
    });
  }

  const evernoteSignin= async ()=> {
    everNoteOauth();
    setEvernote({...getEvernote, isSigninModal: !getEvernote.isSigninModal}); 
  };

  const noteBooksListChange=(e:any)=> {
 
    let parsedValue = JSON.parse(e);
   
    setEvernote({...getEvernote, noteContent:{ ...getEvernote.noteContent, guid: parsedValue.guid} , defaultNoteBook:[parsedValue.name]});

  }

  const  inputHandleChange=(e:any, fields:string)=> {
   
    if(fields === 'title') {
      setEvernote({...getEvernote, noteContent:{ ...getEvernote.noteContent, title: e.target.value} ,titleerror:false});
    }
    if(fields === 'description') {
      setEvernote({...getEvernote, noteContent:{ ...getEvernote.noteContent, content: e.target.value}});
    }
  } 

  const content = (
      <ul className={styles.orderItem}>
        <li onClick={()=>{evernoteOptions('create')}}>Create Note</li>
        {/* <li onClick={()=>{evernoteOptions('share')}}>Share Note</li> */}
      </ul>
    );

    const handleChange =(event:any)=>{
      const searchTerm = event.target.value;
      const searchResults = getEvernote.listOfNotes1.filter((note: any) =>
          note.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setEvernote({
        ...getEvernote,
        searchTerm,
        listOfNotes : searchResults
      });
      
    };

    useEffect(() => {
   
      // {Chat attach file - EverNote}
      const EverNoteShareFeature = planBased.find((item:any) => item.featureid === 790);
      if (EverNoteShareFeature && EverNoteShareFeature.value1 === "Yes") {
        setEverNoteBtn(false); 
      } else {
        setEverNoteBtn(true);
      }
      
    }, [planBased]); 
   

    return (
      <>
        <Popover placement="rightBottom" content={content} overlayClassName="likeDropdown createNote">
        <li className={`${evernoteBtn ? 'disabledIcon':''}`}><span><img src={evernoteicon} /></span> Evernote <span className={`icon_searchrgt ${styles.everNoteIcon}`}></span></li>
        </Popover>

{/* ----------SignIn Modal------- */}
        <Modal visible={getEvernote.isSigninModal} className={`${styles.clearchatmodal} ${"modaloverwrite"} evernote`}>
         <h3 className="headSign">Sign in</h3>
         <div className="everNotetitle"><span><img src={evernoteIcn} alt="" /></span><span className="notes">Evernote</span></div>
         <div className="clearSign">
           <h4>Sign into Evernote</h4>
           <span>You will need to sign in to use this app</span>
         </div>
         <div className={styles.footersection}>
         <URButton className={styles.cancelGrey} onClick={()=> {setEvernote({...getEvernote, isSigninModal:false})}} name="Cancel"></URButton>
          <URButton className={styles.shareGreen} onClick={evernoteSignin} name="Sign in"></URButton>
        </div>
      </Modal>


{/* ----------Create Modal------- */}
      <Modal visible={getEvernote.isCreateModal} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeCreateModalValue}/>
        <h2><b>Create Note</b></h2>
        <div className={styles.everNotetitle}><span><img src={evernoteIcn} alt="" /></span> Evernote</div>
        <div className={styles.middlelayers}>
          <label>Notebook</label>
          <Select
            // defaultValue={getEvernote.defaultNoteBook}
            value={getEvernote.defaultNoteBook}
            onChange={noteBooksListChange}
            className="selTimezone cusSelDrp timezonedrpdwn"    
            dropdownClassName="evernoteSelect"      
          >
            {getEvernote.listOfNoteBooks.map((books:any)=>{
             
              return (
                <Option key={books.guid} value={JSON.stringify(books)}>{books.name}</Option>
              )
            })

            }
          </Select>
          <label>Title *</label>
          <URInput placeHolder="My Box Notes" className={ getEvernote.titleerror?'inputerror' :styles.normalinput} value={getEvernote.noteContent.title} onChange={(e:any)=>{inputHandleChange(e, 'title')}}/>
          {getEvernote.titleerror && <span className="error">Enter the Title</span>}
          <label>Note</label>
          <textarea name="" value={getEvernote.noteContent.content} placeholder="Write a task description" onChange={(e:any)=>{inputHandleChange(e, 'description')}}></textarea>
        </div>



        <div className={styles.footersection}>
          <URButton className={styles.cancelGrey} onClick={closeCreateModalValue} name="Cancel"></URButton>
          <URButton className={styles.shareGreen} name="Create" onClick={sendNote}></URButton>
        </div>
      </Modal> 

    {/* ----------Share Modal------- */}
      <Modal visible={getEvernote.isShareModal} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeCreateModalValue}/>
        <h2><b>Share Note</b></h2>
        <div className={styles.everNotetitle}><span><img src={evernoteIcn} alt="" /></span> Evernote</div>
        <div className={styles.middlelayers}>
          <URInput placeHolder="Search" value={getEvernote.searchTerm} className="leftbarsearch" onChange={handleChange}/>
          <div className='everBox'>
          <ul className={styles.shareList}>
            {getEvernote.listOfNotes.length > 0 ? getEvernote.listOfNotes.map((books:any)=>{
             let modifiedDate = moment((books.created)).format('DD MMM YYYY')
             return (
              <li key={books.guid} className='everBoxs'>
              <p>{books.title}</p>
              <span>{`Last updated: ${modifiedDate}`}</span>
            </li>
             )
             }) : <span className='nodata'>No Data Found</span>
           }
          </ul>
          </div>
          {/* <div className={styles.noeverNote}>
            <img src={evernoteIcnNodata} alt="" />
          </div> */}
        </div>
        <div className={styles.footersection}>
          <URButton className={styles.cancelGrey} onClick={closeCreateModalValue} name="Cancel"></URButton>
          <URButton className={styles.shareGreen} name="Share"></URButton>
        </div>
      </Modal> 

       </>
    )
}